import React from "react";
import { Link } from "react-router-dom";
import { CheckCircleIcon, ChevronLeftIcon } from "@heroicons/react/24/outline";
import DisabledStarRating from "./DisabledStarRating";

interface CandidateDetailsProps {
  id: number;
  name: string;
  job?: string;
  photo: string;
  averageEvaluation: number;
  isHired: boolean;
  loading: boolean;
}

const CandidateDetails: React.FC<CandidateDetailsProps> = ({
  id,
  name,
  job,
  photo,
  averageEvaluation,
  isHired,
  loading,
}) => {
  return (
    <Link
      to={`/candidate/${id}`}
      className={`flex w-auto items-center m-1 border rounded-lg shadow-sm justify-between ${
        isHired ? "border-2 border-green-300" : "bg-white"
      } `}
    >
      <img
        src={photo}
        alt="person"
        className="rounded-xl m-1.5 border shadow-sm w-[88px] h-[90px] bg-white"
      />
      <div className="w-[46%] m-1 py-1 items-stretch justify-start flex-col">
        <h2 className="pb-0.5 font-semibold text-lg">{name} </h2>
        <p className="text-[13px] pb-1 text-gray2 font-normal">{job}</p>
        {isHired && (
          <p className="w-20 flex text-xs text-right rounded-xl border border-green-200 text-green-500 justify-center items-center bg-green-200">
            استخدام
            <CheckCircleIcon className="w-5 h-5 text-green-500 mr-1" />
          </p>
        )}
      </div>
      <div className="w-[34%] h-[90px] md:w-[20%] m-1 py-2 border rounded-xl shadow-sm bg-white flex-col">
        <div className="w-full text-center m-auto text-gray2 text-lg py-2 px-0.5 font-normal flex justify-center items-center">
          <div className="text-base">جزئیات</div>
          <ChevronLeftIcon width={20} height={20} />
        </div>
        <div className="w-full md:text-xl text-center m-auto p-0.5">
          <DisabledStarRating
            rating={averageEvaluation}
            size={16}
            loading={loading}
          />
        </div>
      </div>
    </Link>
  );
};

export default CandidateDetails;
